import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { PrefixType } from '../../interfaces/Prefix'
import { getDeclineReason } from '../../../httpClient/Requests/Api/TEMPO/system'
import { Lookup } from '../../../httpClient/interfaces/Lookup'
import { LookupState } from '../../interfaces/LookupState'

export const initialState: LookupState = {
    data: [],
    loading: false,
    error: null,
}

export const fetchDeclineReasons = (prefix: PrefixType) =>
    createAsyncThunk(`${prefix}/declineReasons/fetchDeclineReasons`, async () => {
        let declineReasons: Lookup[] = []
        if (prefix.includes('TEMPO')) {
            const response = await getDeclineReason()
            declineReasons = response.data
        }
        return declineReasons
    })

const declineReasonsSlice = (prefix: PrefixType) =>
    createSlice({
        name: `${prefix}/declineReasons`,
        initialState,
        reducers: {},
        extraReducers: (builder) => {
            builder.addCase(fetchDeclineReasons(prefix).pending, (state) => ({ ...state, loading: true, error: null }))
            builder.addCase(fetchDeclineReasons(prefix).fulfilled, (state, action) => ({
                ...state,
                data: action.payload,
                loading: false,
                error: null,
            }))
            builder.addCase(fetchDeclineReasons(prefix).rejected, (state, action) => ({
                ...state,
                loading: false,
                error: action.error,
            }))
        },
    })

const declineReasons = (prefix: PrefixType) => declineReasonsSlice(prefix).reducer

export default declineReasons
